import { gql } from "@apollo/client";

export const GET_OFFER_STEPS_QUERY = gql`
    query getOfferSteps($documentTypeId: Int, $offerTypeId: Int, $documentId: Int, $siteId: Int) {
        getOfferSteps(documentTypeId: $documentTypeId, offerTypeId: $offerTypeId, documentId: $documentId, siteId: $siteId) {
            steps {
                id
                stepCode
                title
                route
                alternativeRoute
                completed
                disabled
                error
                validateSteps
                nextSteps {
                    id
                    stepCode
                    title
                    route
                    alternativeRoute
                    completed
                    disabled
                    error
                    validateSteps
                }
                mandatorySteps
            }
            mandatorySteps
            activeStep
        }
    }
`;